/* ==========================================================================
   Al Basit Fragrance — quick-view modal
   Uses Shopify's built-in /products/{handle}.js endpoint (real product
   data, no separate API needed) and the standard /cart/add.js endpoint.
   ========================================================================== */

(function () {
  'use strict';

  var overlay = document.querySelector('[data-ab-qv-overlay]');
  if (!overlay) return;

  var loadingEl = overlay.querySelector('[data-ab-qv-loading]');
  var bodyEl = overlay.querySelector('[data-ab-qv-body]');
  var imageEl = overlay.querySelector('[data-ab-qv-image]');
  var thumbsEl = overlay.querySelector('[data-ab-qv-thumbs]');
  var typeEl = overlay.querySelector('[data-ab-qv-type]');
  var titleEl = overlay.querySelector('[data-ab-qv-title]');
  var priceEl = overlay.querySelector('[data-ab-qv-price]');
  var compareEl = overlay.querySelector('[data-ab-qv-compare]');
  var optionsEl = overlay.querySelector('[data-ab-qv-options]');
  var qtyDisplay = overlay.querySelector('[data-ab-qv-qty-display]');
  var addBtn = overlay.querySelector('[data-ab-qv-add]');
  var errorEl = overlay.querySelector('[data-ab-qv-error]');
  var successEl = overlay.querySelector('[data-ab-qv-success]');
  var linkEl = overlay.querySelector('[data-ab-qv-link]');
  var closeBtn = overlay.querySelector('[data-ab-qv-close]');

  var state = { product: null, selectedOptions: [], quantity: 1 };
  var lastFocusedEl = null;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(0);
    return (window.AB_MONEY_FORMAT || 'Rs. {{amount}}').replace('{{amount}}', amount);
  }

  function findVariant() {
    if (!state.product) return null;
    return state.product.variants.filter(function (v) {
      return v.options.every(function (opt, i) { return opt === state.selectedOptions[i]; });
    })[0];
  }

  function openModal() {
    lastFocusedEl = document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('ab-qv-open');
    closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    overlay.hidden = true;
    document.body.classList.remove('ab-qv-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocusedEl) lastFocusedEl.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeModal();
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  closeBtn.addEventListener('click', closeModal);

  function loadProduct(handle) {
    state.product = null;
    bodyEl.hidden = true;
    loadingEl.hidden = false;
    errorEl.classList.remove('is-visible');
    successEl.classList.remove('is-visible');
    openModal();

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Could not load this product.');
        return res.json();
      })
      .then(function (product) {
        state.product = product;
        state.selectedOptions = (product.variants[0] || {}).options || [];
        state.quantity = 1;
        qtyDisplay.textContent = 1;
        renderProduct();
        loadingEl.hidden = true;
        bodyEl.hidden = false;
      })
      .catch(function () {
        loadingEl.textContent = 'Sorry, this product could not be loaded.';
      });
  }

  function renderProduct() {
    var p = state.product;

    typeEl.textContent = p.type || '';
    typeEl.style.display = p.type ? '' : 'none';
    titleEl.textContent = p.title;
    linkEl.href = p.url;

    if (p.featured_image) {
      imageEl.innerHTML = '<img src="' + p.featured_image + '" alt="' + p.title.replace(/"/g, '&quot;') + '">';
    } else {
      imageEl.innerHTML = '';
    }

    thumbsEl.innerHTML = '';
    if (p.images && p.images.length > 1) {
      p.images.forEach(function (src, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ab-qv-thumb' + (i === 0 ? ' is-active' : '');
        btn.innerHTML = '<img src="' + src + '" alt="">';
        btn.addEventListener('click', function () {
          thumbsEl.querySelectorAll('.ab-qv-thumb').forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
          imageEl.innerHTML = '<img src="' + src + '" alt="">';
        });
        thumbsEl.appendChild(btn);
      });
    }

    optionsEl.innerHTML = '';
    p.options.forEach(function (optionName, index) {
      var values = [];
      p.variants.forEach(function (v) {
        if (values.indexOf(v.options[index]) === -1) values.push(v.options[index]);
      });
      if (values.length <= 1) return;

      var group = document.createElement('div');
      group.className = 'ab-option-group';
      var label = document.createElement('div');
      label.className = 'ab-option-label';
      label.textContent = optionName;
      group.appendChild(label);

      var row = document.createElement('div');
      row.className = 'ab-size-options';
      values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ab-size-btn' + (value === state.selectedOptions[index] ? ' is-active' : '');
        btn.textContent = value;
        btn.addEventListener('click', function () {
          row.querySelectorAll('.ab-size-btn').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state.selectedOptions[index] = value;
          updatePriceAndAvailability();
        });
        row.appendChild(btn);
      });
      group.appendChild(row);
      optionsEl.appendChild(group);
    });

    updatePriceAndAvailability();
  }

  function updatePriceAndAvailability() {
    var variant = findVariant();
    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }
    priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareEl.textContent = formatMoney(variant.compare_at_price);
      compareEl.hidden = false;
    } else {
      compareEl.hidden = true;
    }
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
  }

  overlay.querySelector('[data-ab-qv-qty-decrease]').addEventListener('click', function () {
    state.quantity = Math.max(1, state.quantity - 1);
    qtyDisplay.textContent = state.quantity;
  });
  overlay.querySelector('[data-ab-qv-qty-increase]').addEventListener('click', function () {
    state.quantity = Math.min(10, state.quantity + 1);
    qtyDisplay.textContent = state.quantity;
  });

  addBtn.addEventListener('click', function () {
    var variant = findVariant();
    if (!variant || !variant.available) return;

    addBtn.disabled = true;
    var originalText = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    errorEl.classList.remove('is-visible');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: state.quantity })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        successEl.textContent = 'Added to your cart.';
        successEl.classList.add('is-visible');
        document.dispatchEvent(new CustomEvent('ab:cart:updated'));
        setTimeout(function () {
          if (!document.querySelector('[data-ab-cart-drawer]')) closeModal();
        }, 900);
      })
      .catch(function (err) {
        errorEl.textContent = (err && err.description) || 'Could not add this item to your cart.';
        errorEl.classList.add('is-visible');
      })
      .then(function () {
        addBtn.disabled = false;
        addBtn.textContent = originalText;
        updatePriceAndAvailability();
      });
  });

  // Event delegation: works for any quick-view trigger added now or later,
  // on the homepage grid, collection pages, or related-products section.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ab-quickview-handle]');
    if (!trigger) return;
    e.preventDefault();
    loadProduct(trigger.getAttribute('data-ab-quickview-handle'));
  });
})();
